import { useMemo } from "react";

export const useCompressedTextureSupport = () => {
	return useMemo(() => {
		let compressedTextureSupported = false;
		const c = document.createElement("canvas");
		const gl = c.getContext("webgl");
		const gl2 = c.getContext("webgl2");
		if (
			(gl && gl.getExtension("WEBGL_compressed_texture_astc")) ||
			(gl2 && gl2.getExtension("WEBGL_compressed_texutre_astc"))
		) {
			compressedTextureSupported = true;
		}
		c.remove();
		return compressedTextureSupported;
	}, []);
};
